module.exports = __webpack_public_path__ + "img/e_3_19_r.3e1d1cdb.png";